const country = [
  {
    id: 1,
    name: 'Østfold',
    scale: 20000,
    center: [
      11.6,
      59.4
    ]
  },
  {
    id: 2,
    name: 'Akershus og Oslo',
    scale: 20000,
    center: [
      11.4,
      60
    ]
  },
  {
    id: 4,
    name: 'Hedmark',
    scale: 8000,
    center: [
      11.7,
      61.3
    ]
  },
  {
    id: 5,
    name: 'Oppland',
    scale: 8500,
    center: [
      10,
      61.3
    ]
  },
  {
    id: 6,
    name: 'Buskerud',
    scale: 11000,
    center: [
      9.6,
      60.3
    ]
  },
  {
    id: 7,
    name: 'Vestfold',
    scale: 25000,
    center: [
      10.3,
      59.3
    ]
  },
  {
    id: 8,
    name: 'Telemark',
    scale: 12000,
    center: [
      8.9,
      59.6
    ]
  },
  {
    id: 9,
    name: 'Aust-Agder',
    scale: 14000,
    center: [
      8.4,
      59
    ]
  },
  {
    id: 10,
    name: 'Vest-Agder',
    scale: 16000,
    center: [
      7.5,
      58.5
    ]
  },
  {
    id: 11,
    name: 'Rogaland',
    scale: 12000,
    center: [
      6.7,
      59.1
    ]
  },
  {
    id: 12,
    name: 'Hordaland',
    scale: 12000,
    center: [
      6.5,
      60.3
    ]
  },
  {
    id: 14,
    name: 'Sogn og Fjordane',
    scale: 10000,
    center: [
      7,
      61.3
    ]
  },
  {
    id: 15,
    name: 'Møre og Romsdal',
    scale: 10000,
    center: [
      8,
      62.7
    ]
  },
  {
    id: 16,
    name: 'Sør-Trøndelag',
    scale: 9000,
    center: [
      10.8,
      63.2
    ]
  },
  {
    id: 17,
    name: 'Nord-Trøndelag',
    scale: 9000,
    center: [
      12.6,
      64.5
    ]
  },
  {
    id: 18,
    name: 'Nordland',
    scale: 5300,
    center: [
      16,
      67.3
    ]
  },
  {
    id: 19,
    name: 'Troms',
    scale: 8800,
    center: [
      20.3,
      69.3
    ]
  },
  {
    id: 20,
    name: 'Finnmark',
    scale: 6100,
    center: [
      28,
      70
    ]
  },

  {
    id: 50,
    name: 'Trøndelag',
    scale: 9000,
    center: [
      12.6,
      64.5
    ]
  }
]

export default country
